export default __webpack_public_path__ + "static/media/pton-thesis-slides.7342e472.pdf";